export const CLOSING_EN = {
  header: {
    title: 'Hirings',
    subtitle:
      'This section summarizes the <strong>talents who have accepted your offer</strong>.<br/><br/>Depending on your account permissions, cost details and associated documentation may also be included.',
  },
  bingoHeader: {
    label: 'You hired',
    sublabel: '',
  },
  links: {
    resignation_letter: 'Resignation letter',
    commitment_letter: 'Letter of employment',
    prospect: 'See calculation',
  },
  tag: {
    text: 'Hired on {{hiring_date}}',
  },
};
